import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  CardMedia,
  CardActions,
} from '@mui/material';
import { styled } from '@mui/material/styles';

// Styled components
const HeroSection = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
  color: 'white',
  padding: theme.spacing(15, 0),
  textAlign: 'center',
}));

const FeatureCard = styled(Card)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  transition: 'transform 0.3s ease-in-out',
  '&:hover': {
    transform: 'translateY(-8px)',
  },
}));

const Home = () => {
  const featuredApps = [
    {
      id: 1,
      title: 'Sudoku Journey',
      description: 'Sudoku Journey: Crypto Grandpa Trip Down Memory',
      image: '/images/sudoku_icon.png', // Replace with actual app image
      playStoreLink: 'https://play.google.com/store/apps/details?id=com.kkk.sudokujourney',
    },
    {
      id: 2,
      title: 'Focus Timer',
      description: 'Focus timer and to-do planner for smarter study sessions.',
      image: '/images/timer_icon.png', // Replace with actual app image
      playStoreLink: 'https://play.google.com/store/apps/details?id=com.kkk.focustrack_timer',
    },
    {
      id: 3,
      title: 'NextBallAI',
      description: 'Get the latest Powerball results, AI predictions & smart alerts with NextBallAI!',
      image: '/images/nextball_icon.png', // Replace with actual app image
      playStoreLink: 'https://play.google.com/store/apps/details?id=com.kdev.k.nextballai',
    },
    {
      id: 4,
      title: '로또지니AI',
      description: '로또 당첨 번호 통계와 AI 예측으로 당첨에 한 걸음 더 가까이!',
      image: '/images/genielotto_icon.png', // Replace with actual app image
      playStoreLink: 'https://play.google.com/store/apps/details?id=com.kdev.k.genielottoai',
    },

    // Add more apps as needed
  ];

  return (
    <Box>
      {/* Hero Section */}
      <HeroSection>
        <Container maxWidth="md">
          <Typography variant="h2" component="h1" gutterBottom>
            Welcome to KDev
          </Typography>
          <Typography variant="h5" paragraph>
            We create innovative mobile applications that make a difference
          </Typography>
          <Button
            component={RouterLink}
            to="/apps"
            variant="contained"
            color="secondary"
            size="large"
            sx={{ mt: 2 }}
          >
            Explore Our Apps
          </Button>
        </Container>
      </HeroSection>

      {/* About Section */}
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography variant="h3" component="h2" gutterBottom>
              About KDev
            </Typography>
            <Typography variant="body1" paragraph>
              KDev is a leading mobile app development company based in Seoul, South Korea.
              We specialize in creating high-quality, user-friendly applications that solve
              real-world problems and enhance people's lives.
            </Typography>
            <Typography variant="body1" paragraph>
              Our team of experienced developers and designers work together to deliver
              innovative solutions that meet the highest standards of quality and performance.
            </Typography>
            <Button
              component={RouterLink}
              to="/contact"
              variant="outlined"
              color="primary"
              size="large"
            >
              Get in Touch
            </Button>
          </Grid>
          <Grid item xs={12} md={6}>
            {/* Add company image here */}
            <Box
              component="img"
              src="/images/company-image.jpg" // Replace with actual company image
              alt="KDev Team"
              sx={{
                width: '100%',
                height: 'auto',
                borderRadius: 2,
                boxShadow: 3,
              }}
            />
          </Grid>
        </Grid>
      </Container>

      {/* Featured Apps Section */}
      <Box sx={{ bgcolor: 'grey.100', py: 8 }}>
        <Container maxWidth="lg">
          <Typography variant="h3" component="h2" align="center" gutterBottom>
            Featured Apps
          </Typography>
          <Grid container spacing={4} sx={{ mt: 2 }}>
            {featuredApps.map((app) => (
              <Grid item key={app.id} xs={12} sm={6} md={4}>
                <FeatureCard>
                  <CardMedia
                    component="img"
                    height="200"
                    image={app.image}
                    alt={app.title}
                  />
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Typography gutterBottom variant="h5" component="h3">
                      {app.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {app.description}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button
                      size="small"
                      color="primary"
                      href={app.playStoreLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Get it on Google Play
                    </Button>
                  </CardActions>
                </FeatureCard>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default Home; 